import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const FollowUser = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99999 1.66667C7.81666 1.66667 6.04166 3.44167 6.04166 5.625C6.04166 7.76667 7.71666 9.5 9.89999 9.575C9.96666 9.56667 10.0333 9.56667 10.0833 9.575C10.1 9.575 10.1083 9.575 10.125 9.575C10.1333 9.575 10.1333 9.575 10.1417 9.575C12.275 9.5 13.95 7.76667 13.9583 5.625C13.9583 3.44167 12.1833 1.66667 9.99999 1.66667Z"
          fill={color}
        />
        <path
          d="M14.2333 11.7917C11.9083 10.2417 8.11666 10.2417 5.775 11.7917C4.71666 12.5 4.13333 13.4583 4.13333 14.4833C4.13333 15.5083 4.71666 16.4583 5.76666 17.1583C6.93333 17.9417 8.46666 18.3333 10 18.3333C11.5333 18.3333 13.0667 17.9417 14.2333 17.1583C15.2833 16.45 15.8667 15.5 15.8667 14.4667C15.8583 13.4417 15.2833 12.4917 14.2333 11.7917ZM11.6667 15.1083H10.625V16.15C10.625 16.4917 10.3417 16.775 10 16.775C9.65833 16.775 9.375 16.4917 9.375 16.15V15.1083H8.33333C7.99166 15.1083 7.70833 14.825 7.70833 14.4833C7.70833 14.1417 7.99166 13.8583 8.33333 13.8583H9.375V12.8167C9.375 12.475 9.65833 12.1917 10 12.1917C10.3417 12.1917 10.625 12.475 10.625 12.8167V13.8583H11.6667C12.0083 13.8583 12.2917 14.1417 12.2917 14.4833C12.2917 14.825 12.0083 15.1083 11.6667 15.1083Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default FollowUser;
